export default __webpack_public_path__ + "static/media/Switch-x2.4af212f6.png";